import { Checkbox } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';

import { TextMedium, TextRegular } from 'UiKit/typography';

import AttachmentImage from 'Component/attachment-image';

import styles from './styles.module.css';
import ProductCodeColumn from '../select-product-columns/product-code-column';

const tableList = ({ onOpenPreview, selectedIds, onToggle, isAllSelected, isPartiallySelected, onToggleAll, t }) => [
  {
    name: (
      <Box className={styles['modal__table--col-checkbox']}>
        <Checkbox isChecked={isAllSelected} isIndeterminate={isPartiallySelected} onChange={onToggleAll} />
      </Box>
    ),
    width: '42px',
    component: ({ values }) => {
      return (
        <Box className={styles['modal__table--col-checkbox']}>
          <Checkbox isChecked={selectedIds.includes(values.id)} onChange={() => onToggle(values.id)} />
        </Box>
      );
    },
  },
  {
    name: t('selectProductModal.picture'),
    key: 'image',
    position: 'left',
    width: '90px',
    component: ({ value }) => {
      const images = value ? [{ url: value }] : [];
      return (
        <Box className={styles['modal__table--col-image']}>
          <AttachmentImage images={images} onOpenPreview={onOpenPreview} />
        </Box>
      );
    },
  },
  {
    name: t('selectProductModal.productName'),
    key: 'productName',
    position: 'left',
    width: '300px',
    component: ({ value }) => {
      return <TextMedium className={`${styles['modal__table--col-text']} ${styles['column__text--truncate']}`}>{value}</TextMedium>;
    },
  },
  {
    name: t('selectProductModal.productCode'),
    key: 'sku',
    position: 'left',
    width: '230px',
    component: ({ values }) => {
      return (
        <TextRegular className={`${styles['modal__table--col-text']}`}>
          <ProductCodeColumn values={values} />
        </TextRegular>
      );
    },
  },
];
export default tableList;
